<template>
	<c-dialog ref="dialog" title="维修记录详情" height="70vh" :button="false">
		<c-title style="margin: .3rem .3rem 0;">维修信息</c-title>
		<c-detail style="padding-top: 0;">
			<c-detail-item label="背贴码">
				{{info.produce_unique_code || '-'}}
			</c-detail-item>
			<c-detail-item label="型号">
				{{info.model_name || '-'}}
			</c-detail-item>
			<c-detail-item label="IMEI">
				{{info.produce_imei || '-'}}
			</c-detail-item>
			<c-detail-item label="维修人">
				{{info.create_user_name || '-'}}
			</c-detail-item>
			<c-detail-item label="维修金额">
				<span style="color: #FF6900;">￥{{totalAmount}}</span>
			</c-detail-item>
			<c-detail-item label="状态">
				{{info.repair_state == 2 ? '维修完成' : '维修中'}}
			</c-detail-item>
			<c-detail-item label="创建时间">
				{{info.create_date || '-'}}
			</c-detail-item>
            <c-detail-item label="完成时间">
                {{info.complete_date || '-'}}
            </c-detail-item>
			<c-detail-item label="备注">
				{{info.remark || '-'}}
			</c-detail-item>
		</c-detail>

		<c-title style="margin: 0 .3rem;">维修项目</c-title>
		<c-detail>
			<c-detail-item v-for="(item, i) in details" :key="i" :label="getItemName(item.repair_item)">
				￥{{item.repair_amount}}
			</c-detail-item>
		</c-detail>
	</c-dialog>
</template>

<script>
	export default {
		name: 'repairRecordDetail',

		props: {
			id: [String, Number]
		},

		data() {
			return {
				info: {},
				details: [],
				/*维修项字典，明细表只存 repair_item 代码，label 要显示名称*/
				itemOptions: []
			}
		},

		computed: {
			// 明细金额合计，含负数冲减项，与主表口径一致
			totalAmount() {
				return this.details.reduce((sum, item) => sum + Number(item.repair_amount || 0), 0).toFixed(2);
			}
		},

		methods: {
			open() {
				this.loadItemOptions();
				this.request({
					url: '/repair/record/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.info = data.info || {};
						this.details = data.details || [];
						this.$refs.dialog.open();
					}
				});
			},

			loadItemOptions() {
				if (this.itemOptions.length) return;
				this.request({
					url: '/system/dic/options',
					data: {
						dic_type_code: 'REPAIR_ITEM'
					},
					success: data => {
						this.itemOptions = data || [];
					}
				});
			},

			getItemName(item) {
				let matched = this.itemOptions.find(option => option.value == item);
				return matched ? matched.name : '-';
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
